module.exports = __webpack_public_path__ + "static/img/threePhase_good1.2fa04bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/threePhase_good1.png
// module id = mXzm
// module chunks = 1